import '../scripts/i18n/bootstrap.js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './posthog.js';
import './linkedin-insight.js';
import './google-ads-tag.js';
import './reddit-pixel.js';
import { AboutPage } from '../scripts/Pages.jsx';

createRoot(document.getElementById('root')).render(<AboutPage />);
